import { Route, Switch } from "react-router-dom";

import Layout from "./components/layout/Layout";
import PriceListImportPage from "./pages/PriceListImportPage";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

function App() {
  return (
    <Layout>
      <Switch>
        <Route exact path="/">
          <AuthenticatedTemplate>
            <PriceListImportPage />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <p>Please login...</p>
          </UnauthenticatedTemplate>
        </Route>
        <Route path="/priceListImport">
          <AuthenticatedTemplate>
            <PriceListImportPage />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <p>Please login...</p>
          </UnauthenticatedTemplate>
        </Route>
      </Switch>
    </Layout>
  );
}

export default App;
